
<input type="text" style="width:100px;margin-right: 3px;"  class="datepicker"/>
